var map = {
	"./aed.png": 891,
	"./aud.png": 892,
	"./bgn.png": 893,
	"./bhd.png": 894,
	"./cad.png": 895,
	"./chf.png": 896,
	"./cnh.png": 897,
	"./cny.png": 898,
	"./czk.png": 899,
	"./dkk.png": 900,
	"./eur.png": 901,
	"./gbp.png": 902,
	"./hkd.png": 903,
	"./hrk.png": 904,
	"./huf.png": 905,
	"./idr.png": 906,
	"./ils.png": 907,
	"./inr.png": 908,
	"./jpy.png": 909,
	"./kes.png": 910,
	"./kwd.png": 911,
	"./mxn.png": 912,
	"./myr.png": 913,
	"./nok.png": 914,
	"./nzd.png": 915,
	"./omr.png": 916,
	"./php.png": 917,
	"./pln.png": 918,
	"./qar.png": 919,
	"./ron.png": 920,
	"./rub.png": 921,
	"./sar.png": 922,
	"./sek.png": 923,
	"./sgd.png": 924,
	"./thb.png": 925,
	"./try.png": 926,
	"./ugx.png": 927,
	"./usd.png": 928,
	"./zar.png": 929
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 890;